var jade = require("C:\\Work\\David\\repo\\cartonomy-website\\Cartonomy-Website\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<md-content layout=\"column\" layout-padding class=\"confirm-delete-contact\"><h2 class=\"title\">{{'client.user.remove_contact' | translate}}</h2><div text-center ng-bind-html=\"message\"></div><div layout=\"row\" layout-align=\"center\" class=\"buttons\"><div flex=\"50\" class=\"full-width\"><md-button ng-click=\"acceptDeleteContact()\" aria-label=\"{{'client.yes' | translate}}\" class=\"md-raised md-warn\">{{'client.yes' | translate}}</md-button><md-button ng-click=\"backToCreateOrder()\" aria-label=\"{{'client.no' | translate}}\" class=\"md-raised\">{{'client.no' | translate}}</md-button></div></div></md-content>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/views/orderSetupTabs/confirmDeleteContact.jade
// module id = 691
// module chunks = 0